import React from 'react';
import { Dialog, DialogBody, DialogFooter } from './Dialog';
import { Button } from './Button';

export interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: React.ReactNode;
  /** What will happen, in a sentence, e.g. "“Clean gutters” and its history will be deleted." */
  message?: React.ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  /** 'danger' for something that can't be undone, such as a delete. */
  tone?: 'primary' | 'danger';
  loading?: boolean;
}

export function ConfirmDialog({
  open, onClose, onConfirm, title, message, confirmLabel, cancelLabel = 'Cancel', tone = 'primary', loading,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} title={title} size="sm" hideClose>
      {message && <DialogBody className="pt-1 text-sm text-gray-600 dark:text-gray-400">{message}</DialogBody>}
      <DialogFooter className={message ? undefined : 'mt-4'}>
        <Button variant="ghost" onClick={onClose} disabled={loading}>{cancelLabel}</Button>
        <Button variant={tone} onClick={onConfirm} loading={loading}>{confirmLabel}</Button>
      </DialogFooter>
    </Dialog>
  );
}
